import { Access } from '../../enums';
import { Permission } from '../permission';

const GLOBAL_ADMIN_KEY = 'global-admin';

export const GLOBAL_ADMIN = {
  READ: new Permission({
    key: `${GLOBAL_ADMIN_KEY}:${Access.READ}`,
    description: 'globales Leserecht',
  }),

  WRITE: new Permission({
    key: `${GLOBAL_ADMIN_KEY}:${Access.WRITE}`,
    description: 'globales Schreibrecht',
  }),
};
